module.exports = __webpack_public_path__ + "img/icon_rule.8428de4d.png";